import React from 'react'
import PropTypes from 'prop-types'
import { Close } from '@material-ui/icons'
import { FormattedMessage } from 'react-intl'
import { Dialog, IconButton, makeStyles, Typography } from '@material-ui/core'

import AddOneByOneForm from './AddOneByOneForm/AddOneByOneForm'

const useStyles = makeStyles((themes) => ({
  root: {
    '& .MuiDialog-paper': {
      padding: '3rem',
      width: 'calc(100% - 64px)',
      paddingBottom: '0px !important', //fixing the sticky bottom padding
      [themes.breakpoints.up('md')]: {
        maxWidth: '1280px',
      },
    },
  },
}))

const AddOneByOne = ({
  open,
  onClose,
  onFetch,
  setIsAddAnotherChecked,
  isSendInvitationChecked,
  setIsSendInvitationChecked,
}) => {
  const classes = useStyles()

  return (
    <Dialog
      open={open}
      // onClose={onClose}
      maxWidth="md"
      fullWidth={true}
      aria-labelledby="menus-add-subscriber"
      className={classes.root}
    >
      <div className="flex justify-end">
        <div className="absolute flex justify-center w-full pl-60 h-44">
          <Typography className="text-18 font-bold text-primary flex items-center">
            <FormattedMessage id="subscriber.addOneByOne.dialog.title" />
          </Typography>
        </div>
        <IconButton className="" onClick={onClose}>
          <Close fontSize="small" />
        </IconButton>
      </div>

      <AddOneByOneForm
        onClose={onClose}
        onFetch={async () => {
          await onClose()
          await onFetch()
        }}
        setIsAddAnotherChecked={setIsAddAnotherChecked}
        isSendInvitationChecked={isSendInvitationChecked}
        setIsSendInvitationChecked={setIsSendInvitationChecked}
        isShowAddAnother={true}
      />
    </Dialog>
  )
}

AddOneByOne.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onFetch: PropTypes.func,
}

export default AddOneByOne
